import { useId } from "react";

import { cn } from "@/lib/utils";

export function BruningTrashIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-60 w-74.5", className)}
      fill="none"
      viewBox="0 0 298 240"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}a)`}>
        <g filter={`url(#${id}b)`}>
          <path
            clipRule="evenodd"
            d="M199.217 49.443h-21.769c-.527-2.132-.527-4.219-.527-4.219s-.864 1.635-3.059 3.364c-.356.28-.938.487-1.534.7-.144.05-.289.102-.432.155h-9.236c-.303-2.073-1.601-4.762-1.601-4.762-1.728 1.362-2.92 2.034-3.794 2.527-.477.268-.859.484-1.183.73-.511.726-.946 1.198-1.325 1.505h-25.634c-.027-.543-.027-.886-.027-.886s-.548.344-1.406.886H98.694a8.415 8.415 0 00-8.414 8.414v19.088h-6.59v3.881h6.59v32.881h6.186v1.724h9.707v-1.724h87.37v1.724h9.707v-1.724h6.186V95.772h13.292v-9.547h-13.292v-5.398h6.59v-3.882h-6.702V59.55a10.107 10.107 0 00-10.107-10.107zM76.876 86.225H90.28v9.547H76.876v-9.547zm19.59 29.206h1.75v3.076a3.104 3.104 0 016.208.028v.098a3.105 3.105 0 01-6.209.028v.846h-1.749v-4.076zm98.826 0h-1.749v4.076h1.749v-4.076zm-90.868 0h1.749v4.076h-1.749v-4.076zm98.826 0h-1.749v3.079a3.104 3.104 0 00-6.209.025v.098a3.105 3.105 0 006.209.026v.848h1.749v-4.076z"
            fill="#E15934"
            fillRule="evenodd"
          />
        </g>
        <path
          d="M75.313 55.998A13.976 13.976 0 0189.29 42.02h117.57a15.87 15.87 0 0115.868 15.868v63.849H75.313v-65.74z"
          fill={`url(#${id}c)`}
        />
        <path
          d="M86.142 50.608a2.813 2.813 0 115.627 0v71.13h-5.627v-71.13z"
          fill={`url(#${id}d)`}
        />
        <path
          d="M110.179 50.608a2.813 2.813 0 115.627 0v71.13h-5.627v-71.13z"
          fill={`url(#${id}e)`}
        />
        <path
          d="M134.215 50.608a2.814 2.814 0 015.627 0v71.13h-5.627v-71.13z"
          fill={`url(#${id}f)`}
        />
        <path
          d="M158.253 50.608a2.813 2.813 0 115.626 0v71.13h-5.626v-71.13z"
          fill="#181818"
        />
        <path
          d="M182.289 50.608a2.814 2.814 0 015.627 0v71.13h-5.627v-71.13z"
          fill={`url(#${id}g)`}
        />
        <path
          d="M206.326 50.608a2.814 2.814 0 015.627 0v71.13h-5.627v-71.13z"
          fill={`url(#${id}h)`}
        />
        <path
          d="M86.762 116.987s-10.684-21.422 5.526-33.26c16.19-11.824 14.795-9.208 18.93-16.53 4.127-7.307 2.28-14.728 5.644-19.066 3.363-4.338 6.518-8.314 6.518-8.314s.013 15.434 2.524 19.183c2.511 3.75 4.033 11.578 4.033 11.578s6.025-12.204 10.274-13.098c4.251-.895 8.802-.578 10.651-9.429 1.842-8.822 2.516 0 5.936-9.777 1.137-1.732 2.857-2.867 6.162-8.105 0 0 3.242 13.495 1.593 16.931-1.593 4.22 3.794 12.81 2.209 15.957-1.585 3.147-.946 5.767-3.802 7.88 0 0 4.044 1.145 7.235-7.608 3.181-8.728-1.883-4.683 2.372-13.324.996-2.023 1.04-4.338 2.21-6.341.957-1.641 3.115-2.315 4.038-3.771 2.718-4.303 3.788-8.371 3.788-8.371s0 12.116 2.324 18.244c3.983 10.493 7.913 4.847 9.829 8.802 1.918 3.966 1.953 5.89 1.731 9.045-.222 3.159 1.181 3.498.27 4.382 0 0 .789-1.245 1.441-4.66 1.334-6.983 8.478-14.646 8.478-14.646s-.541 7.865 2.568 12.05c3.108 4.186 6.173 11.924 5.951 15.277-.222 3.354-1.914 5.662-2.784 10.98-.87 5.326.964 6.032-1.205 10.304-2.169 4.273-1.57 9.764-10.263 15.691H86.762v-.004z"
          fill={`url(#${id}i)`}
        />
        <path
          d="M202.724 76.497c-1.829 3.026-6.137 7.025-7.826 10.119-1.419 1.751-.646 4.155-6.745 6.208-2.167.92-3.466 1.665-4.255 2.285.497-1.07.824-2.384.51-3.888-.225-2.338-1.051-5.84.678-7.85 2.239-2.602 4.266-7.116 1.731-10.368-1.217-1.561-3.349-2.695-3.438-2.754-4.27-2.763-3.486-6.108-5.844-10.285-.042 3.301-2.562 4.795-1.498 7.984 1.241 2.939-3.788 9.45-5.846 10.705-2.647 1.613-5.422.491-7.647 2.406-2.516 2.164-7.039 2.319-7.604 9.403-.427 1.904-.152 5.618-.904 6.984.085-1.558-.598-4.6-1.47-5.648-3.553-4.275-3.773-5.549-1.175-10.836 2.073-4.217 4.077-8.898 3.715-13.702-.227-2.87 1.853-7.221 1.696-10.095-.861 1.33-3.407 4.011-3.73 5.202-.602 2.23-2.258 4.057-4.449 5.2a20.884 20.884 0 01-1.147.666c-3.128 1.716-6.531 3.316-9.6 5.01-4.033 2.225-8.428 5.717-8.323 9.905.05 2.053.081 5.047-2.74 5.897-1.604.484-2.773 5.048-4.635 8.157.92-4.758-1.368-13.115-2.125-15.794-.702-2.347-1.391-4.713-2.496-6.936-1.613 2.144-3.043 4.38-4.451 6.638-3.035 4.03-7.037 7.565-11.133 10.543-4.868 3.54-8.715 8.712-10.202 14.16-.687 2.504-1.184 5.152-1.214 7.805v3.369h96.048c.384-.245.578-.37.97-.626 3.333-2.114 6.965-4.383 8.822-7.75 1.616-2.927 1.186-3.324 4.066-7.674 2.058-3.107.469-9.312.617-13.027.024-3.617 2.842-7.927 1.641-11.413h.003zM182.093 98.05c-.009-.148.203-.438.506-.85-.05.319-.122.59-.506.85z"
          fill="#FF9B50"
        />
        <path
          d="M99.159 116.987s.427-10.915 7.815-15.041c2.951-1.647 7.98-9.738 7.98-9.738s4.301 9.37 2.475 14.445c-1.827 5.075-.711 6.736-.711 6.736s3.553-7.66 11.165-11.258c4.277-2.022 5.269-6.41 6.488-10.228.95-2.98-.382-6.99 2.666-9.245 3.61-2.671 8.068-2.118 9.489-4.518.179 1.074-2.729 2.582-3.869 6.058-2.006 6.11 4.218 8.842 4.32 11.322.103 2.479-.091 4.415 1.025 6.676 2.232 4.522-2.154 8.147-2.154 8.147s8.34 2.808 10.899-8.894c1.077-4.927 1.576-7.616 3.966-9.035 1.382-.82 1.005-3.288 4.619-4.597 3.614-1.31 9.036-1.463 11.409-7.624 0 0 .149 10.864-5.02 15.48-5.166 4.613 2.601 9.937 1.334 14.182 0 0 1.762-2.235 6.734-3.527 1.003-.262.959-1.336 2.853-1.798 3.172-.773 6.296-3.081 6.296-3.081s.355 10.277-7.865 15.536H99.159v.002z"
          fill="#FFCC4D"
        />
        <path d="M67.153 110.46h163.874v9.659H67.153z" fill={`url(#${id}j)`} />
        <path d="M82.974 120.119h132.232v81.826H82.974z" fill="#556444" />
        <path d="M215.206 120.119h7.661v81.826h-7.661z" fill="#5E6E4C" />
        <path d="M58.715 133.554h16.598v23.76H58.715z" fill="#515B41" />
        <path d="M61.239 136.968h11.828v16.931H61.239z" fill="#000" />
        <path d="M159.058 159.323h50.57v19.051h-50.57z" fill="#DFBB31" />
        <path d="M82.974 201.946h12.021v4.289H82.974z" fill={`url(#${id}k)`} />
        <path
          d="M82.974 206.235h2.166v10.144h-2.166zm120.212 0h2.166v10.144h-2.166zm-110.357 0h2.166v10.144h-2.166zm120.211 0h2.166v10.144h-2.166z"
          fill="#515B41"
        />
        <path
          d="M203.186 201.946h12.021v4.289h-12.021z"
          fill={`url(#${id}l)`}
        />
        <rect
          fill="#000"
          height="15.695"
          rx="3.844"
          width="7.689"
          x="85.14"
          y="206.235"
        />
        <rect
          fill="#000"
          height="15.695"
          rx="3.844"
          width="7.689"
          x="205.352"
          y="206.235"
        />
        <path d="M222.728 133.554h16.598v23.76h-16.598z" fill="#515B41" />
        <path d="M225.113 136.968h11.828v16.931h-11.828z" fill="#000" />
        <path d="M82.974 121.738h132.232v7.794H82.974z" fill="#556543" />
        <path d="M82.974 127.914h132.232v3.237H82.974z" fill="#6D7D5A" />
        <path d="M82.974 120.119h132.232v3.237H82.974z" fill="#222" />
        <path d="M82.974 145.164h132.232v7.794H82.974z" fill="#556543" />
        <path d="M82.974 151.34h132.232v3.237H82.974z" fill="#6D7D5A" />
        <path d="M82.974 143.546h132.232v3.237H82.974z" fill="#435132" />
        <path d="M82.974 184.739h132.232v7.794H82.974z" fill="#556543" />
        <path d="M82.974 190.915h132.232v3.237H82.974z" fill="#6D7D5A" />
        <path d="M82.974 183.121h132.232v3.237H82.974z" fill="#435132" />
        <path
          d="M82.974 194.151h132.232v7.794H82.974zm-7.661-74.032h7.661v81.826h-7.661z"
          fill="#5E6E4C"
        />
        <path
          d="M82.974 120.119h1.277v74.032h-1.277zm131.149 0h1.277v74.032h-1.277z"
          fill="#404C34"
        />
        <path d="M75.313 120.119h147.554v3.237H75.313z" fill="#181818" />
        <circle cx="106.084" cy="62.455" fill="#FFCC4D" r="0.588" />
        <circle cx="151.57" cy="26.453" fill="#FFCC4D" r="0.588" />
        <circle cx="211.365" cy="20.672" fill="#FFCC4D" r="0.588" />
        <circle cx="102.554" cy="37.628" fill="#FFCC4D" r="0.588" />
        <circle cx="89.577" cy="100.564" fill="#FFCC4D" r="0.196" />
        <circle cx="106.672" cy="47.01" fill="#FFCC4D" r="0.196" />
        <circle cx="141.767" cy="36.844" fill="#FFCC4D" r="0.196" />
        <circle cx="227.445" cy="61.671" fill="#FFCC4D" r="0.196" />
        <circle cx="206.522" cy="76.572" fill="#FFCC4D" r="0.196" />
        <circle cx="191.569" cy="50.5" fill="#FFCC4D" r="0.196" />
        <circle cx="63.541" cy="89.712" fill="#FFCC4D" r="0.196" />
        <circle cx="174.904" cy="56.577" fill="#FFCC4D" r="0.196" />
        <circle cx="158.239" cy="62.655" fill="#FFCC4D" r="0.196" />
        <circle cx="141.375" cy="46.618" fill="#FFCC4D" r="0.196" />
        <circle cx="83.809" cy="73.58" fill="#FFCC4D" r="0.196" />
        <circle cx="96.749" cy="51.088" fill="#FFCC4D" r="0.196" />
        <circle cx="101.77" cy="70.106" fill="#FFCC4D" r="0.196" />
        <circle cx="106.792" cy="89.124" fill="#FFCC4D" r="0.196" />
        <circle cx="111.813" cy="108.142" fill="#FFCC4D" r="0.196" />
        <circle cx="124.908" cy="74.81" fill="#FFCC4D" r="0.196" />
        <circle cx="128.241" cy="50.696" fill="#FFCC4D" r="0.196" />
        <circle cx="185.495" cy="57.165" fill="#FFCC4D" r="0.392" />
        <circle cx="194.115" cy="21.26" fill="#FFCC4D" r="0.392" />
        <circle cx="67.014" cy="68.119" fill="#FFCC4D" r="0.392" />
        <circle cx="118.043" cy="34.004" fill="#FFCC4D" r="0.392" />
        <circle cx="78.752" cy="89.124" fill="#FFCC4D" r="0.392" />
        <circle cx="236.55" cy="101.152" fill="#FFCC4D" r="0.392" />
        <circle cx="220.7" cy="103.632" fill="#FFCC4D" r="0.392" />
        <circle cx="208.43" cy="88.927" fill="#FFCC4D" r="0.392" />
        <circle cx="193.135" cy="105.593" fill="#FFCC4D" r="0.392" />
        <circle cx="178.029" cy="94.417" fill="#FFCC4D" r="0.392" />
        <circle cx="152.158" cy="99.976" fill="#FFCC4D" r="0.392" />
        <circle cx="130.983" cy="54.686" fill="#FFCC4D" r="0.392" />
        <circle cx="186.279" cy="25.473" fill="#FFCC4D" r="0.392" />
        <circle cx="233.131" cy="78.728" fill="#FFCC4D" r="0.588" />
        <circle cx="193.723" cy="74.168" fill="#FFCC4D" r="0.588" />
        <circle cx="198.624" cy="47.794" fill="#FFCC4D" r="0.588" />
        <path
          d="M163.333 174.253v-9.315h6.277v1.624h-4.307v2.219h3.984v1.624h-3.984v2.224h4.325v1.624h-6.295zm7.843 0v-9.315h3.675c.704 0 1.304.126 1.801.378.501.248.881.601 1.142 1.059.264.455.396.99.396 1.606 0 .619-.134 1.151-.401 1.596a2.59 2.59 0 01-1.16 1.019c-.503.237-1.112.355-1.828.355h-2.461v-1.583h2.143c.376 0 .688-.051.937-.154.248-.104.433-.258.555-.464.124-.207.186-.463.186-.769 0-.309-.062-.57-.186-.782a1.149 1.149 0 00-.56-.483c-.249-.112-.562-.168-.941-.168h-1.329v7.705h-1.969zm5.03-4.239l2.316 4.239h-2.175l-2.265-4.239h2.124zm3.375 4.239v-9.315h3.676c.703 0 1.303.126 1.801.378.5.248.881.601 1.141 1.059.264.455.396.99.396 1.606 0 .619-.133 1.151-.4 1.596a2.594 2.594 0 01-1.16 1.019c-.503.237-1.113.355-1.828.355h-2.461v-1.583h2.142c.376 0 .688-.051.937-.154.249-.104.434-.258.555-.464.124-.207.187-.463.187-.769 0-.309-.063-.57-.187-.782a1.146 1.146 0 00-.559-.483c-.249-.112-.563-.168-.942-.168h-1.328v7.705h-1.97zm5.031-4.239l2.315 4.239h-2.174l-2.265-4.239h2.124zm11.935-.418c0 1.015-.192 1.88-.578 2.592-.382.713-.903 1.257-1.564 1.633-.658.373-1.398.56-2.22.56-.828 0-1.571-.188-2.229-.564-.658-.376-1.178-.921-1.56-1.633-.382-.713-.573-1.576-.573-2.588 0-1.016.191-1.88.573-2.593.382-.713.902-1.255 1.56-1.628.658-.376 1.401-.564 2.229-.564.822 0 1.562.188 2.22.564.661.373 1.182.915 1.564 1.628.386.713.578 1.577.578 2.593zm-1.997 0c0-.658-.098-1.213-.295-1.665-.194-.452-.469-.795-.824-1.028-.354-.234-.77-.35-1.246-.35s-.891.116-1.246.35c-.355.233-.631.576-.828 1.028-.194.452-.291 1.007-.291 1.665 0 .658.097 1.213.291 1.664.197.452.473.795.828 1.028.355.234.77.351 1.246.351s.892-.117 1.246-.351c.355-.233.63-.576.824-1.028.197-.451.295-1.006.295-1.664zm3.456 4.657v-9.315h3.675c.704 0 1.304.126 1.801.378.501.248.881.601 1.142 1.059.264.455.396.99.396 1.606 0 .619-.134 1.151-.401 1.596a2.587 2.587 0 01-1.159 1.019c-.504.237-1.113.355-1.829.355h-2.461v-1.583h2.143c.376 0 .688-.051.937-.154.248-.104.433-.258.555-.464.124-.207.186-.463.186-.769 0-.309-.062-.57-.186-.782a1.149 1.149 0 00-.56-.483c-.248-.112-.562-.168-.941-.168h-1.329v7.705h-1.969zm5.031-4.239l2.315 4.239h-2.174l-2.266-4.239h2.125z"
          fill="#000"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}c`}
          x1="149.021"
          x2="149.021"
          y1="42.021"
          y2="121.738"
        >
          <stop stopColor="#435132" />
          <stop offset="1" stopColor="#FF673E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}d`}
          x1="88.956"
          x2="88.956"
          y1="47.794"
          y2="121.738"
        >
          <stop stopColor="#181818" />
          <stop offset="1" stopColor="#E45A35" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}e`}
          x1="112.992"
          x2="112.992"
          y1="47.794"
          y2="121.738"
        >
          <stop stopColor="#181818" />
          <stop offset="1" stopColor="#E45A35" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}f`}
          x1="137.029"
          x2="137.029"
          y1="47.794"
          y2="121.738"
        >
          <stop stopColor="#181818" />
          <stop offset="1" stopColor="#E45A35" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}g`}
          x1="185.103"
          x2="185.103"
          y1="47.794"
          y2="121.738"
        >
          <stop stopColor="#181818" />
          <stop offset="1" stopColor="#E45A35" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}h`}
          x1="209.139"
          x2="209.139"
          y1="47.794"
          y2="121.738"
        >
          <stop stopColor="#181818" />
          <stop offset="1" stopColor="#E45A35" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}i`}
          x1="149.257"
          x2="149.257"
          y1="30.169"
          y2="116.991"
        >
          <stop stopColor="#521100" />
          <stop offset="0.5" stopColor="#FF673E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}j`}
          x1="149.09"
          x2="149.09"
          y1="110.46"
          y2="120.12"
        >
          <stop stopColor="#FF9B50" />
          <stop offset="1" stopColor="#5F6C4A" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}k`}
          x1="88.985"
          x2="88.985"
          y1="201.946"
          y2="206.235"
        >
          <stop stopColor="#282D21" />
          <stop offset="1" stopColor="#515B41" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}l`}
          x1="209.196"
          x2="209.196"
          y1="201.946"
          y2="206.235"
        >
          <stop stopColor="#282D21" />
          <stop offset="1" stopColor="#515B41" />
        </linearGradient>
        <clipPath id={`${id}a`}>
          <path d="M.067 0h297.908v240H.067z" fill="#fff" />
        </clipPath>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="183.715"
          id={`${id}b`}
          width="252.51"
          x="23.547"
          y="-8.648"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_8835_167708"
            stdDeviation="26.664"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function SupportIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-5 text-white", className)}
      fill="none"
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          clipRule="evenodd"
          d="M9.392.523A7.265 7.265 0 005.44 2.255a7.068 7.068 0 00-2.27 3.901c-.091.435-.106.613-.126 1.549L3.022 8.76l-.354.026a3.093 3.093 0 00-.472.063c-.446.14-.925.545-1.148.968-.242.461-.248.52-.248 2.614 0 1.8.004 1.912.08 2.157.162.522.608 1.004 1.135 1.226.26.11.26.11 1.507.11 1.248 0 1.248 0 1.357-.11.11-.108.11-.108.12-3.326.009-2.198 0-3.264-.03-3.363a.595.595 0 00-.162-.244c-.108-.091-.152-.101-.455-.101h-.336l.02-1.028c.016-.858.033-1.091.104-1.418.175-.8.498-1.553.96-2.231.298-.44 1.07-1.216 1.517-1.527a6.13 6.13 0 016.258-.448 6.096 6.096 0 013.225 4.16c.092.426.165 1.439.148 2.043-.012.43-.012.43-.37.45-.401.022-.462.053-.572.294-.067.147-.071.345-.072 3.318-.001 3.464-.007 3.367.23 3.49.081.041.227.06.457.06.337 0 .337 0 .29.089-.087.166-.683.723-.969.907-.578.372-1.226.596-1.838.636-.355.023-.355.023-.427-.207a2.32 2.32 0 00-.615-.998 2.41 2.41 0 00-2.503-.602c-.419.14-.703.321-1.004.639-.291.307-.433.54-.563.926-.433 1.285.336 2.693 1.691 3.097.166.05.365.07.669.07.37 0 .478-.016.747-.109.81-.28 1.404-.882 1.594-1.619.05-.194.05-.194.506-.238 1.553-.153 2.795-.897 3.696-2.214.274-.402.274-.402.55-.45.6-.107 1.085-.453 1.315-.935.125-.263.125-.263.136-2.214.011-1.864.008-1.964-.069-2.243-.256-.928-.936-1.622-1.654-1.687-.234-.02-.234-.02-.235-.671-.002-1.622-.214-2.633-.79-3.76A6.609 6.609 0 0015.27 2.7C14.16 1.545 12.822.838 11.26.58 10.803.505 9.818.475 9.391.523zm-5.367 11.84v2.602H3.31c-.444 0-.773-.018-.874-.047-.216-.064-.542-.388-.606-.603-.035-.116-.048-.655-.048-1.926 0-1.676.004-1.776.08-1.977.093-.248.3-.476.526-.578.138-.062.266-.073.898-.074h.738v2.602zm13.5-2.55c.183.075.47.41.58.677.096.229.096.229.108 2.01.006.979.001 1.837-.011 1.906-.03.164-.186.345-.39.453-.146.078-.229.088-.88.1l-.717.013V9.759h.591c.409 0 .63.017.72.054zm-6.297 6.922c.31.142.559.383.71.69.11.223.13.308.142.612.01.284-.003.395-.069.569-.121.322-.383.595-.737.77-.27.132-.326.145-.618.145-.278 0-.357-.016-.583-.122a1.534 1.534 0 01-.73-.666c-.44-.821-.07-1.716.853-2.07.231-.088.763-.051 1.032.072z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path d="M0 .5h20v20H0z" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}
